import { render } from "./BackgroundStarsBorders.vue?vue&type=template&id=59affe4c&scoped=true"
import script from "./BackgroundStarsBorders.vue?vue&type=script&lang=js"
export * from "./BackgroundStarsBorders.vue?vue&type=script&lang=js"

import "./BackgroundStarsBorders.vue?vue&type=style&index=0&id=59affe4c&language=scss&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59affe4c"]])

export default __exports__